import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  objectToHttpParams,
} from '@tisa-group/cdk';
import {JsonApiResponse} from '@tisa-group/cdk/models';
import {UmpireStatistic, UmpireStatisticType} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';

@Injectable()
export class StatisticsService implements CrudService<UmpireStatistic> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireStatistic[]>> {
    return this.http
      .get(`/statistics`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  listTypes(params?: JsonApiParams): Observable<JsonApiResponse<UmpireStatisticType[]>> {
    return this.http
      .get(`/statistics/types`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
